import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

interface PeriodSelectorState {
  fromDateState: string | null;
  toDateState: string | null;
  selectedFilterState: string;
}

export const initialState: PeriodSelectorState = {
  fromDateState: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
  toDateState: dayjs().format('YYYY-MM-DD'),
  selectedFilterState: 'Daily',
};

const slice = createSlice({
  name: 'periodSelector',
  initialState,
  reducers: {
    setFromDate: (state, action: PayloadAction<string | null>) => {
      state.fromDateState = action.payload;
    },
    setToDate: (state, action: PayloadAction<string | null>) => {
      state.toDateState = action.payload;
    },
    setSelectedFilterValue: (state, action: PayloadAction<string>) => {
      state.selectedFilterState = action.payload;
    },
    setPeriodSelectorState: (
      state,
      action: PayloadAction<{
        fromDate: string | null;
        toDate: string | null;
        selectedFilterValue: string;
      }>,
    ) => {
      state.fromDateState = action.payload.fromDate;
      state.toDateState = action.payload.toDate;
      state.selectedFilterState = action.payload.selectedFilterValue;
    },
  },
});

export const { actions: periodSelectorActions, reducer } = slice;

export default slice.reducer;
